const DayWiseSchedule = {

    "crop_id": "Crop",
    "schedule_variant_id": "Variant",
    "stage_id": "Stage",
    "day": "Day",
    "work_title": "Work to be done",
    "end_day_number": "No of days",
    "description": "Remark",
    "search": "Search",
    "stage_data": "Stage",
    "days_data": "Day Schedule",
    "add_stage": "Add Stage",
    "add_day": "Add Day",

    "dayWiseSchedule": "Day Wise Schedule",

    "error_crop_id": "Select Crop",
    "error_schedule_variant_id": "Select Variant",
    "error_stage_id": "Select Stage",
    "error_day": "Enter Day",
    "error_work_title": "Enter Work to be done",
    "error_end_day_number": "Enter No of days",
    "error_description": "Enter Remark",
    "error_stage_data": "Add at least one stage",
    "error_days_data": "Add at least one day",

    "table_crop": "CROP",
    "table_variant_name": "VARIANT",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",
    "table_image": "IMAGE",
    "table_created_at": "CREATED DATE",
    "table_created_by": "CREATED BY",
    "table_stages": "STAGES",

}

export default DayWiseSchedule;
